import type { AccountDrawerProps } from './components/account-drawer';

import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const _account: AccountDrawerProps['data'] = [
  {
    label: 'Account settings',
    href: paths.dashboard.user.account,
    icon: <Iconify icon="solar:settings-bold-duotone" />,
    translationKey: 'account_settings',
  },
  {
    label: 'Language',
    href: '#',
    icon: null, // Will be replaced with flag icon
    translationKey: 'language',
    isLanguage: true,
  },
  {
    label: 'Layout',
    href: '#',
    icon: <Iconify icon="solar:list-bold" />,
    translationKey: 'layout',
    isLayout: true,
  },
];
